enum PhoneNumberType {
    Mobile,
    Work,
    Office,
    Home,
    Fax,
}

export default PhoneNumberType;
